<template>
  <b-modal
    :id="id"
    :visible="visible"
    modal-class="guide-modal"
    :size="size"
    hide-footer
    hide-header
    centered
  >
    <template #modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <b-button size="sm" variant="outline-danger" @click="close()">
        Close Modal
      </b-button>
      <h5>Modal Header</h5>
    </template>

    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    size: {
      type: String,
      default: "lg"
    },
    visible: {
      type: Boolean
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.guide-modal___BV_modal_content_ {
  border-radius: 16px;
  border-top-color: #1a4de9;
  border-top-width: thick;
}

.modal-dialog,
.modal-content {
  /* 80% of window height */
  height: 80%;
}

.modal-body {
  /* 100% = dialog height, 120px = header + footer */
  max-height: calc(100% - 120px);
  overflow-y: scroll;
}
</style>
